module.exports = __webpack_public_path__ + "static/media/ic_menu_selected_item.98b56ecf.svg";